module.exports = __webpack_public_path__ + "img/Image33.492e0590.jpg";